// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__Et4eN","title":"ClientReferral_title__3GADa","itemText":"ClientReferral_itemText__QJFO5"};